import React from "react";
import { useParams } from "react-router-dom";
import Room from "../components/room";

const RoomPage = () => {
  const { roomId } = useParams();

  return <Room roomId={roomId} />;
};

export default RoomPage;
